// extracted by mini-css-extract-plugin
export default {"arrowButton":"ZS0yl","scrollListWithPagination":"RtdQg","arrowPicto":"eyEvv"};